export class SchoolBmiStatistics {
    underWeight: number;
    normalWeight: number;
    overWeight: number;
    obese: number;
    unSet: number;
    totalMedicalLogs: number;
    incidentCase: number;
    routineCase: number;

}